import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, Grid, IconButton, MenuItem, Select, TextField, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { MuiSelectWithFocus, MuiTextFieldWithFocus } from '../config/MaterialUIConstants';
import { PAYMENT_METHODS } from '../container/Invoice/GenrateInvoice/RecordPayementDialog';
const EditRecordPaymentDialog = ({ open, onClose, payment, index, onSave, onDelete, DatePickerButton }) => {
    const [paymentType, setPaymentType] = useState('credit');
    const [amount, setAmount] = useState('');
    const [paymentReference, setPaymentReference] = useState('');
    const [paymentDate, setPaymentDate] = useState(null);

    useEffect(() => {
        if (open) {
            setPaymentType(payment?.paymentMethod || 'credit');
            setAmount(payment?.amount || '');
            setPaymentReference(payment?.paymentReference || '');
            setPaymentDate(payment?.paymentDate || null);
        }
    }, [open, payment]);

    const handleAmountChange = (value) => {
        const numericValue = value.replace(/[^\d.]/g, '');
        if (numericValue === '' || /^\d*(\.\d{0,2})?$/.test(numericValue)) {
            setAmount(numericValue);
        }
    };
    const handleRefrenceChange = (value) => {
        setPaymentReference(value);
    };

    const handleSave = () => {
        if (amount && parseFloat(amount) > 0) {
            onSave({
                paymentMethod: paymentType,
                amount: amount,
                paymentReference,
                paymentDate,
            });
            onClose();
        }
    };

    const handleCancel = () => {
        setPaymentType(payment?.paymentMethod || 'credit');
        setAmount(payment?.amount || '');
        setPaymentReference(payment?.paymentReference || '');
        setPaymentDate(payment?.paymentDate || null);
        onClose();
    };
    const renderPaymentMethodOption = (method) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {method.logo && <img src={method.logo} alt={method.label} style={{ height: '18px', width: 'auto' }} />}
            <Typography>{method.label}</Typography>
        </Box>
    );

    return (
        <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth aria-labelledby="edit-payment-title" className="commonDialog__600">
            <AppBar position="relative" color="default" elevation={0} sx={{ backgroundColor: '#fff', borderBottom: '1px solid #e0e0e0' }}>
                <Toolbar sx={{ px: 2 }}>
                    <Typography variant="h6" sx={{ flexGrow: 1, color: '#000' }}>
                        Edit Payment
                    </Typography>
                    <IconButton onClick={handleCancel} size="small">
                        <CloseIcon sx={{ color: '#000' }} />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <DialogContent sx={{ px: 3, py: 3 }}>
                <Grid container spacing={1.2} alignItems={'center'}>
                    <Grid item xs={1.2}>
                        <div style={{ marginTop: '31px' }}>
                            <DatePickerButton
                                method={{ ...payment, paymentDate: paymentDate }}
                                actualIndex={index}
                                handleDateChange={(index, date) => {
                                    setPaymentDate(date);
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography sx={{ fontWeight: 500, mb: 1, color: '#000' }}>Select Type</Typography>
                        <Select
                            fullWidth
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                            sx={{ ...MuiSelectWithFocus }}
                            MenuProps={{ PaperProps: { style: { maxHeight: '190px' } } }}
                        >
                            {PAYMENT_METHODS.map((option) => (
                                <MenuItem key={option.key} value={option.key}>
                                    {renderPaymentMethodOption(option)}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>

                    <Grid item xs={3.4}>
                        <Typography sx={{ fontWeight: 500, mb: 1, color: '#000' }}>Payment Amount</Typography>
                        <TextField
                            fullWidth
                            value={amount}
                            onChange={(e) => handleAmountChange(e.target.value)}
                            sx={{ ...MuiTextFieldWithFocus }}
                            InputProps={{
                                startAdornment: (
                                    <p
                                        style={{
                                            paddingLeft: '0',
                                        }}
                                    >
                                        $
                                    </p>
                                ),
                            }}
                        />
                    </Grid>

                    <Grid item xs={3.4}>
                        <Typography sx={{ fontWeight: 500, mb: 1, color: '#000' }}>Reference</Typography>
                        <TextField
                            fullWidth
                            value={paymentReference}
                            onChange={(e) => handleRefrenceChange(e.target.value)}
                            sx={{ ...MuiTextFieldWithFocus }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ px: 2, pb: 2, justifyContent: 'flex-end', paddingTop: '16px !important', borderTop: '1px solid #e0e0e0' }}>
                <Button
                    variant="contained"
                    color="error"
                    onClick={onDelete}
                    sx={{ textTransform: 'uppercase', fontWeight: 500, minWidth: '100px', marginRight: 'auto' }}
                >
                    Delete
                </Button>
                <Button variant="outlined" onClick={handleCancel} sx={{ textTransform: 'uppercase', fontWeight: 500, minWidth: '100px' }}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSave}
                    disabled={!amount || parseFloat(amount) <= 0}
                    sx={{ textTransform: 'uppercase', fontWeight: 500, minWidth: '120px' }}
                >
                    Save Changes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditRecordPaymentDialog;
